"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolboxDriveRemoteContent = void 0;
var base_1 = require("./base");
var promise_1 = require("../../../utils/promise");
var http_1 = require("../../client/http");
var errors_1 = require("../../../common/errors");
var ToolboxDriveRemoteContent = /** @class */ (function (_super) {
    __extends(ToolboxDriveRemoteContent, _super);
    function ToolboxDriveRemoteContent(tb, httpClient, driveSettings, contentName, version) {
        var _this = _super.call(this, httpClient, contentName, driveSettings) || this;
        _this.tb = tb;
        _this.version = version;
        return _this;
    }
    ToolboxDriveRemoteContent.prototype._transferFromRemoteOptions = function (offset, count) {
        return {
            name: this.contentName,
            count: count,
            offset: offset,
            responseType: Uint8Array["fromBase64"] ? "arraybuffer" : "base64",
        };
    };
    ToolboxDriveRemoteContent.prototype._transferFromRemote = function (responseFromRemote, sink, sinkOffset, count, token, p) {
        return __awaiter(this, void 0, void 0, function () {
            var response, base64String, content, size, expectedSize, details;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        response = responseFromRemote;
                        base64String = responseFromRemote.isEncoded
                            ? response.content
                            : new Uint8Array(response.content)["toBase64"]();
                        content = this.tb.createBase64Content(base64String);
                        return [4 /*yield*/, content.size()];
                    case 1:
                        size = _a.sent();
                        if (Number.isInteger(responseFromRemote.to) &&
                            Number.isInteger(responseFromRemote.from)) {
                            expectedSize = responseFromRemote.to - responseFromRemote.from + 1;
                            if (size !== expectedSize) {
                                details = {
                                    actualSize: size,
                                    expectedSize: expectedSize,
                                };
                                throw new errors_1.CommonError("Received chunk data size does not match expected size.", null, errors_1.ErrorCodes.Mismatch, details);
                            }
                        }
                        return [4 /*yield*/, this.tb.transfer(content, sink.content, 0, sinkOffset, count, token, p)];
                    case 2:
                        _a.sent();
                        content.dispose();
                        return [2 /*return*/];
                }
            });
        });
    };
    ToolboxDriveRemoteContent.prototype._prepareContentForRemote = function (specificContent, offset, count, token, progress) {
        var _this = this;
        var targetContent = this.tb.createTempContent();
        var p = this.tb.transfer(specificContent.content, targetContent, offset, 0, count, token, progress);
        p = (0, promise_1.using)(p, function (part) {
            return _this.tb.compress(part, _this.tb.createBase64Content(), { type: "gzip" }, token);
        });
        return (0, promise_1.using)(p, function (partContent) {
            targetContent.dispose();
            var chunk = new http_1.HttpTransferChunk(partContent.data(), _this.version, "gzip", "base64");
            if (Uint8Array["fromBase64"]) {
                chunk.data = Uint8Array["fromBase64"](partContent.data());
                chunk.encoding = undefined;
            }
            return (0, promise_1.promiseResolve)(chunk);
        });
    };
    return ToolboxDriveRemoteContent;
}(base_1.BaseDriveRemoteContent));
exports.ToolboxDriveRemoteContent = ToolboxDriveRemoteContent;
